<template>
    <form>
        <form-alert />

        <div class="form-group">
            <label for="name">
                Name
            </label>
            <form-input
                v-model="mutableData.name"
                name="name"
                data-vv-as="Name"
            />
        </div>

        <div class="form-group">
            <label for="description">
                Description
            </label>
            <form-textarea
                v-model="mutableData.description"
                name="description"
                rows="5"
                data-vv-as="Description"
            />
        </div>

        <div class="form-group">
            <label for="sequence_number">
                Sequence Number
            </label>
            <form-input
                v-model="mutableData.sequence_number"
                name="sequence_number"
                data-vv-as="Sequence Number"
            />
        </div>

        <div class="form-group">
            <label for="is_archived">
                Status
            </label>
            <form-select
                v-model="mutableData.is_archived"
                name="is_archived"
                :options="{ 0: 'Active', 1: 'Archived' }"
                data-vv-as="Status"
            />
        </div>

        <div class="form-group">
            <label for="lesson_file">
                Replace PDF File
            </label>
            <div class="custom-file">
                <input
                    id="lesson_file"
                    ref="lesson_file"
                    type="file"
                    class="custom-file-input"
                    @change="handleFileUpload()"
                />
                <label
                    class="custom-file-label"
                    for="lesson_file"
                >
                    Choose file
                </label>
            </div>
        </div>

        <div class="form-group">
            <label for="presentation_file">
                {{ (mutableData.presentation_filename ? 'Replace' : '') }} PowerPoint File
            </label>

            <div class="custom-file">
                <input
                    id="presentation_file"
                    ref="presentation_file"
                    type="file"
                    class="custom-file-input"
                    @change="handleFileUpload()"
                />
                <label
                    class="custom-file-label"
                    for="presentation_file"
                >
                    Choose file
                </label>
            </div>
        </div>

        <div class="form-group">
            <label for="image_file">
                {{ (mutableData.image_filename ? 'Replace' : '') }} Image
            </label>
            <div class="custom-file">
                <input
                    id="image_file"
                    ref="image_file"
                    type="file"
                    class="custom-file-input"
                    @change="handleFileUpload()"
                />
                <label
                    class="custom-file-label"
                    for="image_file"
                >
                    Choose file
                </label>
            </div>
        </div>

        <form-alert />

        <button
            :disabled="isSending"
            class="btn btn-success btn-block"
            @click.prevent="submitMultiPartForm()"
        >
            Save
        </button>
    </form>
</template>

<script>
import bsCustomFileInput from "bs-custom-file-input";
import Form from "../mixins/Form.js";

export default {
  mixins: [
    Form,
  ],

  mounted() {
    // displays filename in <input>
    $(document).ready(() => {
      bsCustomFileInput.init();
    });
  },

  methods: {
    handleFileUpload() {
      this.files = {
        lesson_file: this.$refs.lesson_file.files[0],
        presentation_file: this.$refs.presentation_file.files[0],
        image_file: this.$refs.image_file.files[0],
      };
    },
  },
};
</script>
